import type { FC } from "react";

import { DraftProvider } from "../../providers/draft-provider";
import { DraftCard } from "./draft-card";

export interface DraftProps {
  draftId: string;
  placement?: "floating" | "inline";
}

export const Draft: FC<DraftProps> = ({ draftId, placement = "floating" }) => (
  <DraftProvider id={draftId} placement={placement}>
    <DraftCard />
  </DraftProvider>
);
